<template>
  <div>
    <p
      v-if="valid"
      v-cloak
      class="mt-2 text-sm text-neutral-700"
    >
      <fa
        :icon="['fal', 'check']"
        class="fa-fw text-lg text-green-700"
      />
      <span class="text-sm pl-1">{{ $t('password.password-is-strong') }}</span>
    </p>
    <div
      v-else
      v-cloak
      class="mt-3 rounded grid grid-cols-2 space-y-1"
    >
      <div
        v-for="(rule, i) in rules"
        :key="i"
        class="flex items-center"
      >
        <fa
          :icon="rule.valid ? ['fal', 'check'] : ['fal', 'times']"
          :class="rule.valid ? 'fa-fw text-lg text-green-700' : 'fa-fw text-lg text-red-700'"
        />
        <span class="text-sm pl-1 text-neutral-700">
          {{ rule.message }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { passwordStrength } from '@/config';

export default {
  name: 'VetsterPasswordStrength',

  props: {
    password: {
      type: String,
      default: null,
    },
  },

  computed: {
    rules() {
      return [
        {
          message: this.$t('password.has-at-least-six-characters'),
          valid: this.password?.length >= 6,
        },
        {
          message: this.$t('password.has-one-uppercase-letter'),
          valid: /[A-Z]/.test(this.password),
        },
        {
          message: this.$t('password.has-one-lowercase-letter'),
          valid: /[a-z]/.test(this.password),
        },
        {
          message: this.$t('password.has-one-number'),
          valid: /\d/.test(this.password),
        },
      ];
    },
    valid() {
      return passwordStrength(this.password);
    },
  },
};
</script>
